import { createFileRoute } from '@tanstack/react-router';

import { PageHeader, PageLayout } from '@keboola/design';
import { ExternalLink } from '@keboola/design/icons';

import { RESOURCES } from '../../features/apps/constants';

export const Route = createFileRoute('/_public/resources')({
  component: ResourcesPage,
  head: () => ({ meta: [{ title: 'Resources | Keboola Developer Portal' }] }),
});

function ResourcesPage() {
  return (
    <PageLayout>
      <PageLayout.Header>
        <PageHeader.Index
          title="Resources"
          description="Documentation and tooling for building Keboola components."
        />
      </PageLayout.Header>

      {/* A list, not a bare div grid: these are five sibling links and `ul` is what conveys that
          (and their count) to a screen reader. */}
      <ul className="tw:m-0 tw:grid tw:list-none tw:grid-cols-1 tw:gap-4 tw:p-0 tw:sm:grid-cols-2 tw:lg:grid-cols-3">
        {RESOURCES.map((resource) => (
          <li key={resource.link}>
            <a
              href={resource.link}
              target="_blank"
              rel="noopener noreferrer"
              className="tw:flex tw:h-full tw:items-start tw:justify-between tw:gap-3 tw:rounded-lg tw:border tw:border-border tw:bg-card tw:p-5 tw:no-underline tw:transition-shadow tw:hover:shadow-md"
            >
              {/* `text-foreground` explicitly: the whole card is a link, so without it the title
                  inherits the link colour and every tile reads as branded text. */}
              <span className="tw:font-semibold tw:text-foreground">{resource.title}</span>
              {/* Decorative — "opens in a new tab" is already conveyed by the link text plus the
                  browser, and an accessible name here would be read after every title. */}
              <ExternalLink
                className="tw:size-4 tw:shrink-0 tw:text-muted-foreground"
                aria-hidden="true"
              />
            </a>
          </li>
        ))}
      </ul>
    </PageLayout>
  );
}
